import type { SyntheticEvent } from "react";

/**
 * Swaps a failed image to the fallback source once. The guard on the current
 * `src` attribute stops a loop if the fallback itself fails to load.
 */
export const swapToFallbackSource = (
  event: SyntheticEvent<HTMLImageElement>,
  fallbackSrc: string,
): void => {
  const image = event.currentTarget;
  if (image.getAttribute("src") !== fallbackSrc) {
    image.setAttribute("src", fallbackSrc);
  }
};
